import { AppContextProvider } from '../context/AppContext';

import Filters from './Filters';
import Legend from './Legend';
import MapWithContext from './MapWithContext';
import CountryDialog from './CountryDialog';

/**
 * App component.
 *
 * @param {Object} props                - component props
 * @param {Array}  props.wpCountryPosts - WordPress country posts data
 * @param {Array}  props.wpRegionTerms  - WordPress Region terms data
 * @param {Array}  props.wpProgramTerms - WordPress Program terms data
 */
export default function App( { wpCountryPosts, wpRegionTerms, wpProgramTerms } ) {
	return (
		<div className="tcc-map__wrapper">
			<AppContextProvider>
				<Filters
					wpCountryPosts={ wpCountryPosts }
					wpRegionTerms={ wpRegionTerms }
					wpProgramTerms={ wpProgramTerms }
				/>
				<div className="tcc-map__canvas">
					<MapWithContext wpCountryPosts={ wpCountryPosts } />
					<CountryDialog />
				</div>
			</AppContextProvider>

			<Legend />
		</div>
	);
}
